import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class SiteDailyCountEventVm {
	id: number;
	currentSite?: string;
	orgId?: number;
	orgName?: string;
	siteId: number;
	status?: any;
	statusStr?: string;
	eventDate: Date;
	eventDateStr?: string;
	submissionDate?: Date;
	submissionDateStr?: string;
	submissionUserName?: string;
	submissionUserEmail?: string;
	submissionUserId?: number;
	isComplete: boolean;
	securityStamp?: string;
	dateGuidCreated: Date;
	isGuidExpired: boolean;
	siteDailyCountInventoryList?: any;
	friendlyId?: string;
	site?: any;
	canEditDailyCountAfterCompleted: boolean;
	siteReportingDays?: string;
	isSpecificDays: boolean;
	eventId: number;
	eventName?: string;
	isUnscheduled?: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'id': new UntypedFormControl(0, [...(validators['id'] ?? []), ...[Validators.required]]),
			'currentSite': new UntypedFormControl(null, [...(validators['currentSite'] ?? []), ...[]]),
			'orgId': new UntypedFormControl(null, [...(validators['orgId'] ?? []), ...[]]),
			'orgName': new UntypedFormControl(null, [...(validators['orgName'] ?? []), ...[]]),
			'siteId': new UntypedFormControl(0, [...(validators['siteId'] ?? []), ...[Validators.required]]),
			'status': new UntypedFormControl('', [...(validators['status'] ?? []), ...[Validators.required]]),
			'statusStr': new UntypedFormControl(null, [...(validators['statusStr'] ?? []), ...[]]),
			'eventDate': new UntypedFormControl('', [...(validators['eventDate'] ?? []), ...[Validators.required]]),
			'eventDateStr': new UntypedFormControl(null, [...(validators['eventDateStr'] ?? []), ...[]]),
			'submissionDate': new UntypedFormControl(null, [...(validators['submissionDate'] ?? []), ...[]]),
			'submissionDateStr': new UntypedFormControl(null, [...(validators['submissionDateStr'] ?? []), ...[]]),
			'submissionUserName': new UntypedFormControl(null, [...(validators['submissionUserName'] ?? []), ...[]]),
			'submissionUserEmail': new UntypedFormControl(null, [...(validators['submissionUserEmail'] ?? []), ...[]]),
			'submissionUserId': new UntypedFormControl(null, [...(validators['submissionUserId'] ?? []), ...[]]),
			'isComplete': new UntypedFormControl(false, [...(validators['isComplete'] ?? []), ...[]]),
			'securityStamp': new UntypedFormControl(null, [...(validators['securityStamp'] ?? []), ...[]]),
			'dateGuidCreated': new UntypedFormControl('', [...(validators['dateGuidCreated'] ?? []), ...[Validators.required]]),
			'isGuidExpired': new UntypedFormControl(false, [...(validators['isGuidExpired'] ?? []), ...[]]),
			'siteDailyCountInventoryList': new UntypedFormControl([], [...(validators['siteDailyCountInventoryList'] ?? []), ...[]]),
			'friendlyId': new UntypedFormControl(null, [...(validators['friendlyId'] ?? []), ...[]]),
			'site': new UntypedFormControl(null, [...(validators['site'] ?? []), ...[]]),
			'canEditDailyCountAfterCompleted': new UntypedFormControl(false, [...(validators['canEditDailyCountAfterCompleted'] ?? []), ...[]]),
			'siteReportingDays': new UntypedFormControl(null, [...(validators['siteReportingDays'] ?? []), ...[]]),
			'isSpecificDays': new UntypedFormControl(false, [...(validators['isSpecificDays'] ?? []), ...[]]),
			'eventId': new UntypedFormControl(0, [...(validators['eventId'] ?? []), ...[Validators.required]]),
			'eventName': new UntypedFormControl(null, [...(validators['eventName'] ?? []), ...[]]),
			'isUnscheduled': new UntypedFormControl(null, [...(validators['isUnscheduled'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['eventDate', {"orderId":0,"sortColumn":"eventDate","searchColumn":"eventDate","searchColumns":null,"includeInExcel":true,"exportColumn":null,"displayName":"Date","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['statusStr', {"orderId":1,"sortColumn":"statusStr","searchColumn":"statusStr","searchColumns":null,"includeInExcel":true,"exportColumn":null,"displayName":"Status","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['submissionDate', {"orderId":2,"sortColumn":"submissionDate","searchColumn":"submissionDate","searchColumns":null,"includeInExcel":true,"exportColumn":null,"displayName":"Submission Date","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['submissionUserName', {"orderId":3,"sortColumn":"submissionUserName","searchColumn":"submissionUserName","searchColumns":null,"includeInExcel":true,"exportColumn":null,"displayName":"Completed By","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): SiteDailyCountEventVmFromFg {
		return new SiteDailyCountEventVmFromFg(fg);
	}
}

export class SiteDailyCountEventVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get id(): number {
		return this.fg.get('id').value;
	}
	set id(val) {
		this.fg.get('id').setValue(val);
	}

	get currentSite(): string {
		return this.fg.get('currentSite').value;
	}
	set currentSite(val) {
		this.fg.get('currentSite').setValue(val);
	}

	get orgId(): number {
		return this.fg.get('orgId').value;
	}
	set orgId(val) {
		this.fg.get('orgId').setValue(val);
	}

	get orgName(): string {
		return this.fg.get('orgName').value;
	}
	set orgName(val) {
		this.fg.get('orgName').setValue(val);
	}

	get siteId(): number {
		return this.fg.get('siteId').value;
	}
	set siteId(val) {
		this.fg.get('siteId').setValue(val);
	}

	get status(): any {
		return this.fg.get('status').value;
	}
	set status(val) {
		this.fg.get('status').setValue(val);
	}

	get statusStr(): string {
		return this.fg.get('statusStr').value;
	}
	set statusStr(val) {
		this.fg.get('statusStr').setValue(val);
	}

	get eventDate(): Date {
		return this.fg.get('eventDate').value;
	}
	set eventDate(val) {
		this.fg.get('eventDate').setValue(val);
	}

	get eventDateStr(): string {
		return this.fg.get('eventDateStr').value;
	}
	set eventDateStr(val) {
		this.fg.get('eventDateStr').setValue(val);
	}

	get submissionDate(): Date {
		return this.fg.get('submissionDate').value;
	}
	set submissionDate(val) {
		this.fg.get('submissionDate').setValue(val);
	}

	get submissionDateStr(): string {
		return this.fg.get('submissionDateStr').value;
	}
	set submissionDateStr(val) {
		this.fg.get('submissionDateStr').setValue(val);
	}

	get submissionUserName(): string {
		return this.fg.get('submissionUserName').value;
	}
	set submissionUserName(val) {
		this.fg.get('submissionUserName').setValue(val);
	}

	get submissionUserEmail(): string {
		return this.fg.get('submissionUserEmail').value;
	}
	set submissionUserEmail(val) {
		this.fg.get('submissionUserEmail').setValue(val);
	}

	get submissionUserId(): number {
		return this.fg.get('submissionUserId').value;
	}
	set submissionUserId(val) {
		this.fg.get('submissionUserId').setValue(val);
	}

	get isComplete(): boolean {
		return this.fg.get('isComplete').value;
	}
	set isComplete(val) {
		this.fg.get('isComplete').setValue(val);
	}

	get securityStamp(): string {
		return this.fg.get('securityStamp').value;
	}
	set securityStamp(val) {
		this.fg.get('securityStamp').setValue(val);
	}

	get dateGuidCreated(): Date {
		return this.fg.get('dateGuidCreated').value;
	}
	set dateGuidCreated(val) {
		this.fg.get('dateGuidCreated').setValue(val);
	}

	get isGuidExpired(): boolean {
		return this.fg.get('isGuidExpired').value;
	}
	set isGuidExpired(val) {
		this.fg.get('isGuidExpired').setValue(val);
	}

	get friendlyId(): string {
		return this.fg.get('friendlyId').value;
	}
	set friendlyId(val) {
		this.fg.get('friendlyId').setValue(val);
	}

	get site(): any {
		return this.fg.get('site').value;
	}
	set site(val) {
		this.fg.get('site').setValue(val);
	}

	get canEditDailyCountAfterCompleted(): boolean {
		return this.fg.get('canEditDailyCountAfterCompleted').value;
	}
	set canEditDailyCountAfterCompleted(val) {
		this.fg.get('canEditDailyCountAfterCompleted').setValue(val);
	}

	get siteReportingDays(): string {
		return this.fg.get('siteReportingDays').value;
	}
	set siteReportingDays(val) {
		this.fg.get('siteReportingDays').setValue(val);
	}

	get isSpecificDays(): boolean {
		return this.fg.get('isSpecificDays').value;
	}
	set isSpecificDays(val) {
		this.fg.get('isSpecificDays').setValue(val);
	}

	get eventId(): number {
		return this.fg.get('eventId').value;
	}
	set eventId(val) {
		this.fg.get('eventId').setValue(val);
	}

	get eventName(): string {
		return this.fg.get('eventName').value;
	}
	set eventName(val) {
		this.fg.get('eventName').setValue(val);
	}

	get isUnscheduled(): boolean {
		return this.fg.get('isUnscheduled').value;
	}
	set isUnscheduled(val) {
		this.fg.get('isUnscheduled').setValue(val);
	}
}
